import { CloudCommand } from "../types.js";

export const searchGifs: CloudCommand = {
    action: "GIF/SEARCH",
    commandName: "gif.searchGifs",
    buildPayload: ({ params }) => {
        const { query } = (params ?? {}) as { query?: unknown };
        return { query };
    },
};
